import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/frontend-next/src/app/_ui/components/core/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkTracked"] */ "/app/frontend-next/src/app/_ui/components/core/LinkTracked.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.8.3_@swc+helpers@0.5.19_next@16.2.6_patch_hash=c5541455e773de1062085fcfbcf1_630af0082986833ac5edc01cbcc69602/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
